import React, {Component} from 'react';
import LightBoxFullScreenComponent from "../../../../shared/lightboxFullScreen/components/LightBoxFullScreenComponent";
import isMobile from 'is-mobile';
import SlideComponent from "../../slide/components/slideComponent";
import TitleAndDescription from '../../titleAndDescription/components/TitleAndDescriptionComponent';
import { withTranslation } from 'react-i18next';

import '../style/OurPlatform.scss';

class OurPlatformComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showEnVideo: false,
            showFrVideo: false,
        };
    }

    render() {
        let legends = (
            <div className="legends">
                {isMobile() ? (
                    <SlideComponent
                        dots={true}
                        infinite={false}
                        speed="500"
                        slidetoshow={1}
                        slideScroll={1}
                        slidesPerRow={1}
                    >
                        <TitleAndDescription
                            title={this.props.t("Retailers")}
                            description={this.props.retailers}
                        />
                        <TitleAndDescription
                            title={this.props.t("Our Platform")}
                            description={this.props.ourPlataform}
                        />
                        <TitleAndDescription
                            title={this.props.t("Brands")}
                            description={this.props.brands}
                        />
                    </SlideComponent>
                ) : (<>
                        <TitleAndDescription
                            title={this.props.t("Retailers")}
                            description={this.props.retailers}
                        />
                        <TitleAndDescription
                            title={this.props.t("Our Platform")}
                            description={this.props.ourPlataform}
                        />
                        <TitleAndDescription
                            title={this.props.t("Brands")}
                            description={this.props.brands}
                        />
                    </>
                )}
            </div>
        ); 
        let content1 = (
            <div className="legends-container" style={
                {backgroundImage: `linear-gradient(black, black), url(${process.env.PUBLIC_URL}/images/landing/how-it-works.png)`}
            }>
                {legends}
            </div>
        );
        return (
            <>
                {content1}
                {this.state.showEnVideo &&
                <LightBoxFullScreenComponent
                    isVideo={true}
                    handleClick={() => this.setState({showEnVideo: false})}>
                    <iframe className="how-it-works-iframe" title="Blanc English"
                            src="https://www.youtube.com/embed/mIRV169RzR8?controls=0" frameborder="0"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen/>

                </LightBoxFullScreenComponent>
                }
                {this.state.showFrVideo &&
                <LightBoxFullScreenComponent
                    isVideo={true}
                    handleClick={() => this.setState({showFrVideo: false})}>
                    <iframe className="how-it-works-iframe" title="Blanc Français"
                            src="https://www.youtube.com/embed/8b58Qf8WNUE?controls=0" frameborder="0"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowFullCcreen/>
                </LightBoxFullScreenComponent>
                }
                <div className="join-us-btn">
                    <button onClick={this.props.openRegister} className="link register">{this.props.t('JOIN US')}</button>
                </div>
            </>
        )
    }
}

export default withTranslation()(OurPlatformComponent);